import { render, staticRenderFns } from "./item-test-rule.vue?vue&type=template&id=cbc3b38e&scoped=true"
import script from "./item-test-rule.vue?vue&type=script&lang=js"
export * from "./item-test-rule.vue?vue&type=script&lang=js"
import style0 from "./item-test-rule.vue?vue&type=style&index=0&id=cbc3b38e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbc3b38e",
  null
  
)

export default component.exports